import { createSvgIcon } from '@mui/material';

export const AccountIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 42 42">
    <path
      fill="currentColor"
      d="M3.5 15.75h33.25c.4641 0 .9092.1844 1.2374.5126.3282.3282.5126.7733.5126 1.2374V35c0 .4641-.1844.9093-.5126 1.2374-.3282.3282-.7733.5126-1.2374.5126H5.25c-.46413 0-.90925-.1844-1.23744-.5126C3.68437 35.9093 3.5 35.4641 3.5 35V15.75Zm1.75-10.5H31.5v7h-28V7c0-.46413.18437-.90925.51256-1.23744C4.34075 5.43437 4.78587 5.25 5.25 5.25Zm21 19.25V28h5.25v-3.5h-5.25Z"
    />
  </svg>,
  'AccountIcon',
);
